<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column is-three-quarters-desktop">

        <h1 class="subtitle is-4 has-text-centered">
          Import Token
        </h1>

        <article class="message">
          <div class="message-body">
            <span class="icon has-text-info">
             <i class="fas fa-info-circle"></i>
            </span>
            You can import tokens which exist on the currently selected network. To import tokens from other networks, switch the network in Metamask.
          </div>
        </article>

        <div class="field">
          <label class="label">Token Address</label>
          <div class="control">
            <input
              v-model="address"
              class="input"
              type="text"
              @paste.prevent="parseAddress"
              @change.prevent="parseAddress"
            >
          </div>
        </div>

        <div class="field">
          <label class="label">Symbol</label>
          <div class="control">
            <div class="control">
              <input
                :value="symbol"
                disabled
                class="input"
                type="text"
              >
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">Name</label>
          <div class="control">
            <div class="control">
              <input
                :value="name"
                disabled
                class="input"
                type="text"
              >
            </div>
          </div>
        </div>

        <div class="field">
          <div class="control has-text-right">
            <button
              class="button is-link"
              @click.prevent="importToken"
            >
              Import
            </button>
          </div>
        </div>

        <br>

        <h1 class="subtitle is-4 has-text-centered">
          Tokens
        </h1>
        <div class="table-container">
          <table class="table is-fullwidth   table is-hoverable">
            <thead>
              <tr>
                <th>Name</th>
                <th>Symbol</th>
                <th>Address</th>
                <th>Chain ID</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(t, key) in paginatedTokens" :key="key">
                <td>{{ t.name }}</td>
                <td>{{ t.symbol }}</td>
                <td>{{ t.address }}</td>
                <td>{{ t.chainId }}</td>
                <td>
                  <button class="button is-danger is-small" @click="removeToken(key)">Delete</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination Section -->
        <div class="pagination is-centered">
          <ul class="pagination-list">
            <!-- Previous Page Button -->
            <li>
              <a
                @click="goToPage(currentPage - 1)"
                :class="{ 'is-disabled': currentPage === 1 }"
                class="pagination-previous"
              >&laquo; Previous</a>
            </li>

        <!-- แสดงข้อมูลหน้าและจำนวนหน้าทั้งหมด -->
        <li>
         <span class="pagination-ellipsis">
           {{ currentPage }} of {{ totalPages }}
         </span>
        </li>

            <!-- Next Page Button -->
            <li>
              <a
                @click="goToPage(currentPage + 1)"
                :class="{ 'is-disabled': currentPage === totalPages }"
                class="pagination-next"
              >Next &raquo;</a>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import loader from '@/mixins/loader'
import utilities from '@/mixins/utilities'
import WalletService from '@/services/wallet'

export default {
  mixins: [
    loader,
    utilities
  ],

  data () {
    return {
      address: '',
      name: '',
      symbol: '',
      tokens: [],
      currentPage: 1, //
      perPage: 10 //
    }
  },

  computed: {
    ...mapState(['chainId', 'wrappedTokens']),
    paginatedTokens () {
      const start = (this.currentPage - 1) * this.perPage
      const end = start + this.perPage
      return this.tokens.slice(start, end)
    },
    totalPages () {
      return Math.ceil(this.tokens.length / this.perPage)
    }
  },

  async mounted () {
    await this.fetchPageData()
  },

  methods: {
    async importToken() {
      this.execWithLoader(async () => {
        const newToken = {
          address: this.address,
          name: this.name,
          symbol: this.symbol,
          chainId: this.chainId
        }

        let tokens = JSON.parse(window.localStorage.getItem('tokens')) || []

        const isDuplicate = tokens.some(token => token.address === newToken.address)
        const isWrappedToken = this.wrappedTokens.some(token => token.wrappedToken === newToken.address)

        if (!isDuplicate && !isWrappedToken) {
        // เพิ่มโทเค็นล่าสุดไปที่ลำดับแรกของรายการ tokens .unshift
        tokens.unshift(newToken);
          // tokens.push(newToken)
          window.localStorage.setItem('tokens', JSON.stringify(tokens))
          this.tokens = tokens
          await this.fetchPageData()
          console.log('Token imported successfully!')
        } else {
          if (isDuplicate) {
            console.log('Token already exists in the list.')
          } else if (isWrappedToken) {
            console.log('Token is already Interface and imported.')
          }
        }
      }, 'Error fetching imported tokens')
    },

    async removeToken(index) {
      this.execWithLoader(async () => {
        let tokens = JSON.parse(window.localStorage.getItem('tokens')) || []

        if (tokens.length > index) {
          tokens.splice(index, 1)
          window.localStorage.setItem('tokens', JSON.stringify(tokens))
          this.tokens = tokens
          await this.fetchPageData()
        }
      }, 'Error removing token')
    },

    async parseAddress (evt) {
      this.execWithLoader(async () => {
        if (this.address === '') {
          this.address = evt.clipboardData.getData('text')
        }

        this.name = await WalletService.getTokenName(this.address)
        this.symbol = await WalletService.getTokenSymbol(this.address)
      }, 'Address does not exist and is invalid on this network')
    },

    async fetchPageData() {
      this.execWithLoader(async () => {
        // อ่านข้อมูลโทเค็นจาก local storage และอัปเดตค่า this.tokens
        this.tokens = JSON.parse(window.localStorage.getItem('tokens')) || []
      }, 'Error fetching tokens')
    },

    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
      }
    }
  }
}
</script>
